import { BIcon } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBIcon when migrating. */
export const EgBIcon = createEgBootstrapProxy("EgBIcon", BIcon);
